/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = All
 *
 * 1 = Active
 *
 * 2 = LostSale
 *
 * 3 = Quoted
 *
 * 4 = Order
 *
 * 5 = Invoice
 *
 * 6 = Delivery
 *
 * 7 = SendToLostSale
 */
export enum EnquiryCrmStatus {
  All = 0,
  Active = 1,
  LostSale = 2,
  Quoted = 3,
  Order = 4,
  Invoice = 5,
  Delivery = 6,
  SendToLostSale = 7,
}
